export default {
  title: '数据和要求',
  upload: '上传数据',
  sample: '样例',
  result: '质检结果',
  qualified: '合格',
  unqualified: '不合格',
  editor: '评论',
  choise: '请选择',
  enter: '请输入',
  collectTemp0:	'录音时长要求',
  collectTemp1:	'最短',
  collectTemp2:	'最长',
  js: {
    unfinished: '未完成',
    error: '错误',
    nodatas: '没有数据',
    finish: '请完成检验',
    whole: '全局题目未完成',
    the: '第',
    item: '个标注题目未完成'
  },
  skip: '跳过任务',
  skip1: '原因',
  skip2: '规则不适用',
  skip3: '数据有问题',
  skip4: '任务太难',
  skip5: '说明',
  skip6: '请填写说明'
}



// WEBPACK FOOTER //
// ./src/lang/zh/collect.js